<template>
  <section id="portofolio" class="section portfolio">
    <div class="section-container reveal">
      <div class="section-head">
        <div>
          <span class="section-label">Portofolio</span>
          <h2 class="section-title">Proyek yang telah kami kembangkan</h2>
        </div>
      </div>

      <div class="portfolio-grid">
        <article v-for="project in projects" :key="project.name" class="project-card card">
          <div class="project-image-wrap">
            <img :src="project.image" :alt="project.name" loading="lazy" decoding="async" />
          </div>
          <div class="project-body">
            <span class="project-year">{{ project.year }}</span>
            <h3>{{ project.name }}</h3>
            <p>{{ project.description }}</p>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import ayoboga from "@/assets/ayoboga.png";
import kwuikip from "@/assets/kwuikip.png";
import ekta from "@/assets/e-kta.png";
import synapse from "@/assets/synapse.jpg";
import sinaran from "@/assets/sinaran.png";
import binpes from "@/assets/binpes.png";

export default {
  name: "AppPortofolio",
  data() {
    return {
      projects: [
        {
          year: "2019",
          name: "Ayoboga Education",
          description:
            "Platform kuliner untuk kelas memasak online dan offline, lengkap dengan resep, tutorial, serta layanan katering.",
          image: ayoboga,
        },
        {
          year: "2021",
          name: "Entreumart KWU IKIP Siliwangi",
          description:
            "Marketplace internal kampus untuk mendukung pembelajaran kewirausahaan mahasiswa secara praktis.",
          image: kwuikip,
        },
        {
          year: "2022",
          name: "E-KTA Pertahkindo",
          description:
            "Sistem kartu anggota elektronik untuk tenaga ahli konsultan yang terintegrasi dengan sistem pembayaran.",
          image: ekta,
        },
        {
          year: "2023",
          name: "Synapse Ecosystem",
          description:
            "Aplikasi HR untuk KPI, absensi, komisi, dan evaluasi kinerja 360 derajat dengan dashboard terpusat.",
          image: synapse,
        },
        {
          year: "2023",
          name: "Sinaran Disdagin Kota Bandung",
          description:
            "Platform pengumpulan dan pengelolaan data mal serta ritel untuk kebutuhan dinas perdagangan.",
          image: sinaran,
        },
        {
          year: "2023",
          name: "Binpes KONI Kab. Bandung",
          description:
            "Website informasi atlet binaan dengan data jadwal latihan, prestasi, dan aktivitas pembinaan.",
          image: binpes,
        },
      ],
    };
  },
};
</script>

<style scoped>
.portfolio {
  padding-top: 28px;
}

.portfolio-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}

.project-card {
  flex: 0 1 calc((100% - 32px) / 3);
  min-width: 0;
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(255, 255, 255, 0.75);
  transition: transform 0.24s ease, box-shadow 0.24s ease;
}

.project-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-soft);
}

.project-image-wrap {
  height: 190px;
  background: #f3f7ff;
}

.project-image-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.project-body {
  padding: 18px;
}

.project-year {
  display: inline-block;
  margin-bottom: 10px;
  padding: 5px 10px;
  border-radius: 999px;
  background: rgba(13, 77, 164, 0.1);
  color: var(--primary);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
}

.project-body h3 {
  font-size: 1.1rem;
  color: var(--text);
}

.project-body p {
  margin-top: 8px;
  font-size: 0.93rem;
}

@media (max-width: 980px) {
  .project-card {
    flex-basis: calc((100% - 32px) / 3);
  }
}

@media (max-width: 760px) {
  .portfolio-grid {
    gap: 10px;
  }

  .project-card {
    flex-basis: calc((100% - 20px) / 3);
  }

  .project-image-wrap {
    height: 88px;
  }

  .project-body {
    padding: 8px 8px 10px;
  }

  .project-year {
    margin-bottom: 6px;
    padding: 4px 6px;
    font-size: 0.54rem;
    letter-spacing: 0.02em;
  }

  .project-body h3 {
    font-size: 0.68rem;
    line-height: 1.3;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .project-body p {
    margin-top: 4px;
    font-size: 0.56rem;
    line-height: 1.4;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
}

@media (max-width: 420px) {
  .project-card {
    flex-basis: calc((100% - 10px) / 2);
  }

  .project-image-wrap {
    height: 106px;
  }

  .project-body h3 {
    font-size: 0.78rem;
  }

  .project-body p {
    font-size: 0.64rem;
  }
}
</style>
